
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from "@/components/ui/button";

interface LocationPage {
  name: string;
  href: string;
}

interface DesktopMenuProps {
  navigation: Array<{ name: string; href: string }>;
  locationPages: Array<LocationPage>;
}

const DesktopMenu: React.FC<DesktopMenuProps> = ({ navigation, locationPages }) => {
  const location = useLocation();

  return (
    <div className="hidden md:flex items-center space-x-6">
      <nav className="flex space-x-6 items-center justify-end">
        {navigation.map((item) => (
          <Link
            key={item.name}
            to={item.href}
            className={`text-sm font-medium transition-colors hover:text-piano-gold flex items-center ${
              location.pathname === item.href
                ? 'text-piano-gold'
                : 'text-piano-black dark:text-white'
            }`}
          >
            {item.name}
          </Link>
        ))}
      </nav>

      <Button asChild className="bg-piano-gold hover:bg-piano-gold/90 text-white font-medium">
        <Link to="/kontakt">Gratis prøvetime</Link>
      </Button>
    </div>
  );
};

export default DesktopMenu;
